import React, { useEffect, useState } from 'react';
import './SerieDetailsModal.css';
import ContentDetails from '../ContentDetails/ContentDetails';
import DetailListItem from '../DetailListItem/DetailListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useContentDetails } from '../../hooks/useContentDetails';
import { useNavigate } from 'react-router-dom';
import TemplateModal from '../TemplateModal/TemplateModal';

const SerieDetailsModal = ({ serieId, onClose }) => {
    const { headerContent, episodes, loading, error } = useContentDetails({ serieId });
    const navigate = useNavigate();
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [selectedContent, setSelectedContent] = useState(null);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    const formatPlaylist = (startFromEpisode = null) => {
        const availableEpisodes = episodes
            .filter(ep => ep.status === 'available')
            .map(ep => ({
                id: ep.contentId,
                title: ep.title,
                url: ep.url,
                type: 'video',
                additionalInfo: ep.additionalInfo,
                thumbnailUrl: ep.thumbnailUrl
            }));

        return availableEpisodes;
    };

    const handleHeaderClick = () => {
        const availableContents = episodes.filter(content => content.status === 'available');
        if (availableContents.length > 0) {
            const firstEp = availableContents[0];
            const playlist = formatPlaylist();
            navigate(`/video/${firstEp.contentId}`, {
                state: {
                    playlist: playlist,
                    from: "/"
                }
            });
            onClose();
        } else {
            setSelectedContent(headerContent);
            setShowTemplateModal(true);
        }
    }

    const handleItemClick = (content) => {
        if (!content) return;

        if (content.status === 'available') {
            const playlist = formatPlaylist();
            navigate(`/video/${content.contentId}`, {
                state: {
                    playlist: playlist,
                    from: "/"
                }
            });
            onClose();
        } else {
            setSelectedContent(content);
            setShowTemplateModal(true);
        }
    }

    const handleTemplateModalClose = () => {
        setShowTemplateModal(false);
        setSelectedContent(null);
    };

    return (
        <div className="serie-details-modal-overlay">
            <div className="serie-details-modal-content">
                <button className="close-button" onClick={onClose}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>

                {loading ? (
                    <div className="serie-details-skeleton">
                        <div className="skeleton-header" />
                        <div className="skeleton-episodes">
                            {[1, 2, 3].map((_, index) => (
                                <div key={index} className="skeleton-episode">
                                    <div className="skeleton-thumbnail" />
                                    <div className="skeleton-text">
                                        <div className="skeleton-title" />
                                        <div className="skeleton-description" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : error ? (
                    <div className="error-message">
                        {error}
                    </div>
                ) : !headerContent ? (
                    <div className="error-message">
                        Série não encontrada
                    </div>
                ) : !episodes || episodes.length === 0 ? (
                    <div className="error-message">
                        Nenhum episódio disponível
                    </div>
                ) : (
                    <>
                        <ContentDetails
                            thumbnailUrl={headerContent.thumbnailUrl}
                            title={headerContent.title}
                            subtitle={headerContent.subtitle}
                            description={headerContent.description}
                            onClick={handleHeaderClick}
                        />

                        <div className="serie-details-episodes-container">
                            {episodes.map((ep) => (
                                <DetailListItem
                                    key={ep.contentId}
                                    title={ep.title}
                                    subtitle={ep.subtitle}
                                    description={ep.description}
                                    thumbnail={ep.thumbnailUrl}
                                    status={ep.status}
                                    onClick={() => handleItemClick(ep)}
                                />
                            ))}
                        </div>
                    </>
                )}

                {showTemplateModal && selectedContent && (
                    <TemplateModal
                        templateId={selectedContent.salesPage}
                        onClose={handleTemplateModalClose}
                    />
                )}
            </div>
        </div>
    );
};

export default SerieDetailsModal; 